import { NavLink } from "react-router-dom";
import UserButton from "./UserButton";
import SidebarNav from "../../../components/Sidebar/SidebarNav";
import PagesNav from "./PagesNav";
import { ScanUserQuota } from "../../../components/QR/ScanUserQuota";

const Header = () => {
  return (
    <header className="sticky top-0 z-5 w-full transition-all duration-300">
      <div className="header-glass shadow-2 relative">
        <div className="container px-4 md:px-6 h-5rem flex align-items-center justify-content-between">
          {/* Logo Section */}
          <div className="flex align-items-center">
            <NavLink
              to="/"
              className="flex align-items-center no-underline gap-2 group"
            >
              <span className="flex align-items-center justify-content-center w-2rem h-2rem md:w-3rem md:h-3rem border-circle bg-primary text-primary-inverse transition-transform duration-300 group-hover:rotate-180">
                <i className="pi pi-bolt text-lg md:text-xl" />
              </span>
              <div className="flex flex-column justify-content-center gap-1">
                <span className="text-md md:text-xl font-black text-color line-height-1 ">
                  {process.env.REACT_APP_CUSTOMER}
                </span>
                <span className="text-sm md:text-lg font-black text-color line-height- font-italic">
                  <span className="logo-text-gradient"> By Doing Sports</span>
                </span>
              </div>
            </NavLink>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex align-items-center gap-4">
            <PagesNav />
          </nav>

          {/* Actions Section */}
          <div className="flex align-items-center gap-2 md:gap-4">
            <div className="hidden md:flex items-center gap-2">
              <ScanUserQuota />
              <UserButton />
            </div>
            <div className="flex align-items-center gap-2 md:hidden">
              <ScanUserQuota />
              <SidebarNav />
            </div>
          </div>
        </div>

        {/* Bottom Gradient Border */}
        <div className="header-gradient-border"></div>
      </div>
    </header>
  );
};

export default Header;
